import router from '@/router'
import { DateTime } from 'luxon'
import { useFormStore } from '@/stores/form'
import useFormatDate from '@/composables/useFormatDate'

export default function () {
  const formStore = useFormStore()
  const { formateDateFromDDMMYYYY } = useFormatDate()
  const birthday =
    formStore.form.values.dateOfBirth && formateDateFromDDMMYYYY(formStore.form.values.dateOfBirth)

  const res = {
    serviceTransactionId: router.currentRoute.value.params.serviceId,
    lookupHealthStatusId: formStore.form.values.lookupHealthStatusId,
    isStillMarried: formStore.form.values.isStillMarried,
    // Transform to number of years
    dateOfBirth:
      birthday &&
      DateTime.now().diff(birthday, 'years').years &&
      Math.floor(DateTime.now().diff(birthday, 'years').years),
    showRequestNaturalizationForChildsFamily:
      formStore.extraMap.showRequestNaturalizationForChildsFamily,
    isChildWorking: formStore.form.values.isChildWorking,
    identifierType: formStore.form.values?.edit_relativesInformation?.identifierType
  }
  return res
}
